import React from 'react';
import IneffizienteProzesse_border from '../assets/problem/IneffizienteProzesse_border.avif';
import HoheFehlerquote_border from '../assets/problem/HoheFehlerquote_border.avif';
import SchwacheLeadgen_border from '../assets/problem/SchwacheLeadgen_border.avif';
import FehlendeTransparenz_border from '../assets/problem/FehlendeTransparenz_border.avif';
import cardblur from '../assets/problem/card-blur.avif';

const Problem = () => {
  const cards = [
    {
      title: "Ineffiziente Prozesse",
      description: "Zu viele Abläufe laufen noch manuell: Rechnungen prüfen, Daten übertragen, Berichte erstellen. Das frisst Kapazitäten und verlangsamt dein Team.",
      image: IneffizienteProzesse_border
    },
    {
      title: "Hohe Fehlerquote",
      description: "Manuelle Arbeit ist fehleranfällig: Falsche Rechnungen, vergessene Follow-ups oder unklare Zuständigkeiten kosten Zeit und Vertrauen.",
      image: HoheFehlerquote_border
    },
    {
      title: "Schwache Leadgenerierung",
      description: "Neue Leads entstehen oft zufällig und ohne klaren Prozess. Viele potenzielle Kunden gehen unterwegs verloren, weil Follow-ups fehlen oder unstrukturiert laufen.",
      image: SchwacheLeadgen_border
    },
    {
      title: "Fehlende Transparenz",
      description: "Daten liegen verstreut in unterschiedlichen Systemen. Entscheidungen basieren auf Bauchgefühl statt auf klaren, aktuellen Informationen.",
      image: FehlendeTransparenz_border
    }
  ];

  return (
    <section className="min-h-[45vh] bg-gradient-to-b from-[#030507] to-[#070709] text-white py-20 px-4 relative">
      <div className="max-w-[1344px] mx-auto">
        <div className="mb-12">
          {/*<span className="font-['Geist'] font-light text-xs text-white tracking-[0.02em] pb-3 block">
            DAS PROBLEM
          </span>*/}
          {/*<h2 className="font-['Geist'] font-medium text-[48px] text-white tracking-[-0.02em] text-left mb-6 leading-tight">
            Manuelle Prozesse bremsen Wachstum
          </h2>*/}
          <h2 className="font-['Calsans'] font-medium text-2xl sm:text-[48px] text-white tracking-[0.02em] text-left mb-6 leading-tight">
            Manuelle Prozesse <span className="sm:hidden"><br/></span><span className="hidden sm:inline"> </span>bremsen Wachstum
          </h2>
          <p className="font-['Geist'] font-light text-sm sm:text-base text-[#ADB0B9] max-w-[925px] pb-[54px]">
            Ob Vertrieb, Backoffice oder Kundenservice. Täglich verschwenden Teams Stunden mit wiederholenden Aufgaben, Daten-<br className="hidden sm:block" />Chaos und unklaren Prozessen. Das führt zu Fehlern, langsamen Entscheidungen und verpassten Wachstumsmöglichkeiten.
          </p>
        </div>

        <div className="relative z-10 -mt-30 md:-mt-20">
          <div className="flex md:grid md:grid-cols-2 lg:grid-cols-4 gap-6 overflow-x-auto pb-6 -mx-4 px-4 md:mx-0 md:px-0 no-scrollbar pt-16">
            {cards.map((card, index) => (
              <div key={index} className="group bg-[#0D0E12] rounded-2xl p-6 h-[386px] w-[280px] flex-shrink-0 md:w-full md:max-w-[318px] mx-auto overflow-visible relative transition-all duration-500 ease-home-hero-card-transform hover:-translate-y-3.5 hover:shadow-[0px_8px_20px_#000,0px_24px_30px_0px_RGBA(0,0,0,0.6)]">
                <div className="relative">
                  <h3 className="font-['Geist'] font-medium text-lg text-white tracking-[-0.02em] pb-2.5">
                    {card.title}
                  </h3>
                  <p className="font-['Geist'] font-light text-[14px] sm:text-sm text-[#ADB0B9] tracking-[-0.02em] mb-4">
                    {card.description}
                  </p>
                </div>
                <div className="absolute inset-0 w-full h-full">
                  <img 
                    src={card.image} 
                    alt={card.title}
                    className="w-full h-full object-cover"
                    style={{ opacity: 1 }}
                    loading="lazy"
                  />
                  <div className="absolute -top-2 -right-2 w-[105%] h-[105%] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <img 
                      src={cardblur} 
                      alt="" 
                      className="w-full h-full object-cover rotate-180"
                      aria-hidden="true"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
